import { render, staticRenderFns } from "./summaryIndex.vue?vue&type=template&id=afc24d5a&scoped=true"
import script from "./summaryIndex.vue?vue&type=script&lang=js"
export * from "./summaryIndex.vue?vue&type=script&lang=js"
import style0 from "./summaryIndex.vue?vue&type=style&index=0&id=afc24d5a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afc24d5a",
  null
  
)

export default component.exports